import React, { Component } from 'react';
import { Scrollbars } from 'react-custom-scrollbars';
import { SpringSystem } from 'rebound';

export default class Scrollbar extends Component {
  constructor(props, ...rest) {
    super(props, ...rest);

    this.getScrollTop = this.getScrollTop.bind(this);
    this.getScrollHeight = this.getScrollHeight.bind(this);
    this.scrollTop = this.scrollTop.bind(this);
    this.handleSpringUpdate = this.handleSpringUpdate.bind(this);
  }

  componentDidMount() {
    this.springSystem = new SpringSystem();
    this.spring = this.springSystem.createSpring();
    this.spring.addListener({ onSpringUpdate: this.handleSpringUpdate });
  }

  componentWillUnmount() {
    this.springSystem.deregisterSpring(this.spring);
    this.springSystem.removeAllListeners();
    this.springSystem = undefined;
    this.spring.destroy();
    this.spring = undefined;
  }

  getScrollTop() {
    return this.scrollbars.getScrollTop();
  }

  getScrollHeight() {
    return this.scrollbars.getScrollHeight();
  }

  scrollTop(top) {
    const { scrollbars } = this;
    const scrollTop = scrollbars.getScrollTop();

    this.spring.setCurrentValue(scrollTop).setAtRest();
    this.spring.setEndValue(top);
  }

  handleSpringUpdate(spring) {
    const { scrollbars } = this;
    const val = spring.getCurrentValue();
    scrollbars.scrollTop(val);
  }

  renderThumb({ style, ...props }) {
    const thumbStyle = {
      backgroundColor: this.props.color === 'white' ? '#81737f' : '#81737f',
      borderRadius: '5px'
    };
    return <div style={{ ...style, ...thumbStyle }} {...props} />;
  }

  render() {
    const { color } = this.props;

    return (
      <Scrollbars
        renderThumbVertical={props => this.renderThumb(props, color)}
        className={'scroll-bars'}
        {...this.props}
        ref={Scroll => {
          this.scrollbars = Scroll;
        }}
      />
    );
  }
}



// WEBPACK FOOTER //
// ./src/script/libs/Scrollbar.js